import React, { useState } from 'react';

const CATEGORIES = [
  { id: 'environment', name: 'Environment', emoji: '🌱' },
  { id: 'education', name: 'Education', emoji: '📚' },
  { id: 'health', name: 'Health', emoji: '❤️' },
  { id: 'community', name: 'Community', emoji: '🤝' },
  { id: 'technology', name: 'Technology', emoji: '💻' },
  { id: 'arts', name: 'Arts & Culture', emoji: '🎨' },
  { id: 'business', name: 'Business', emoji: '💼' },
  { id: 'social', name: 'Social Impact', emoji: '✊' },
  { id: 'food', name: 'Food', emoji: '🍽️' },
  { id: 'creatives', name: 'Creatives', emoji: '🎭' }
];

export const InterestSelection = ({ onComplete, onSkip }) => {
  const [selected, setSelected] = useState([]);

  const toggleInterest = (categoryId) => {
    if (selected.includes(categoryId)) {
      setSelected(selected.filter(id => id !== categoryId));
    } else {
      setSelected([...selected, categoryId]);
    }
  };

  const handleSave = async () => {
    if (selected.length === 0) {
      alert('Please select at least one interest');
      return;
    }

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://backend.sbwom.com'}/api/auth/profile`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ interests: selected })
      });

      if (response.ok) {
        onComplete();
      } else {
        throw new Error('Failed to save interests');
      }
    } catch (error) {
      console.error('Error saving interests:', error);
      alert('Failed to save interests. You can set them later in your profile.');
      onComplete();
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
        <h2 className="text-2xl font-bold text-brown-800 mb-4">
          What are you interested in?
        </h2>
        <p className="text-brown-600 mb-6">
          Select at least 3 categories to personalize your campaign feed
        </p>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 mb-6">
          {CATEGORIES.map(cat => (
            <button
              key={cat.id}
              onClick={() => toggleInterest(cat.id)}
              className={`p-4 rounded-lg border-2 transition-all ${
                selected.includes(cat.id)
                  ? 'border-green-600 bg-green-50'
                  : 'border-gray-300 hover:border-green-400'
              }`}
            >
              <div className="text-3xl mb-2">{cat.emoji}</div>
              <div className="font-semibold text-sm">{cat.name}</div>
            </button>
          ))}
        </div>

        <div className="text-center text-sm text-brown-600 mb-4">
          Selected: {selected.length} / 10
        </div>

        <div className="flex gap-3">
          <button
            onClick={onSkip}
            className="flex-1 bg-gray-300 hover:bg-gray-400 text-brown-800 font-bold py-3 px-4 rounded-lg"
          >
            Skip for now
          </button>
          <button
            onClick={handleSave}
            disabled={selected.length === 0}
            className="flex-1 bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-4 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Save Interests
          </button>
        </div>
      </div>
    </div>
  );
};

export default InterestSelection;
